module.exports = __webpack_public_path__ + "img/a.aeb9388e.jpg";